<template>
	<header id="header">
		<div class="nav">
			<IconBase class="icon" iconName="home" width="80" height="80"
					  viewBox="0 0 80 85"
					  v-on:onIconClicked="onMenuItemClicked(0, true)">
				<IconHome/>
			</IconBase>
			<div v-if="isLoggedIn"
				 class="menuItem menuEnabled"
				 :class="{menuItemActive: selectedMenuItem === menuItems[1],}"
				 v-on:click="onMenuItemClicked(1, true)">{{menuItems[1]}}
			</div>
			<div v-if="isLoggedIn"
				 class="menuItem"
				 :class="{menuItemActive: selectedMenuItem === menuItems[2],
				 menuEnabled: currentShowId}"
				 v-on:click="onMenuItemClicked(2)">{{menuItems[2]}}
			</div>
			<div v-if="isLoggedIn"
				 class="menuItem"
				 :class="{menuItemActive: selectedMenuItem === menuItems[3],
				 menuEnabled: currentShowId}"
				 v-on:click="onMenuItemClicked(3)">{{menuItems[3]}}
			</div>
		</div>
		<div class="nav-right">
			<div v-if="isLoggedIn">
				<Logout v-on:logout="isLoggedIn = false"/>
			</div>
			<div class="logo">
				<img src="@/assets/imgs/cms_logo.png" alt="CMS Logo"
					 height="58">
			</div>
		</div>
	</header>
</template>

<script>
	import IconBase from '@/components/icons/IconBase.vue';
	import IconHome from '@/components/icons/IconHome.vue';
	import {EventBus} from '@/services/EventBus.js';
	import Logout from '@/components/user/Logout.vue';
	import isLoggedIn from '@/services/IsLoggedIn.js';


	export default {
		name: "Header",
		components: {
			IconBase,
			IconHome,
			Logout
		},
		data() {
			return {
				selectedMenuItem: '',
				menuItems: ['Home', 'Inhalte', 'Editieren', 'Vorschau'],
				routerLinks: ['/', '/content/', '/showedit/', '/preview/'],
				currentShowId: '',
				isLoggedIn: false
			}
		},
		methods: {
			onMenuItemClicked(index, removeShow) {
				if (removeShow) this.currentShowId = '';

				this.selectedMenuItem = this.menuItems[index];
				this.$router.push({path: this.routerLinks[index] + this.currentShowId});
			}
		},
		created() {
			this.selectedMenuItem = this.menuItems[0];
			document.title = 'CMS Modellbespielung';

			EventBus.$on('onCurrentShow', showId => {
				this.currentShowId = showId;
			});

			EventBus.$on('onSelectedMenuItem', selectedMenuItem => {
				this.selectedMenuItem = selectedMenuItem;
			});

			EventBus.$on('onSelectedMenuItem', selectedMenuItem => {
				this.selectedMenuItem = selectedMenuItem;
			});

			EventBus.$on('onLogin', () => {
				this.isLoggedIn = true;
			});
		},
		mounted() {
			this.isLoggedIn = isLoggedIn();
		}
	}
</script>

<style scoped>
	#header {
		display: flex;
		justify-content: space-between;
		border: solid 1px black;
		font-family: "BrownLLWeb-Bold", Helvetica, sans-serif;
	}

	#header .icon {
		float: left;
		border-right: solid 1px black;
	}

	#header .menuItem {
		float: left;
		height: 80px;
		font-size: 25px;
		text-decoration: none;
		padding-top: 22px;
		padding-left: 20px;
		padding-right: 20px;
		border-right: solid 1px black;
		background-color: white;
		pointer-events: none;
		color: black;
		opacity: 0.3;
	}

	#header .menuItem:hover {
		cursor: pointer;
		color: white;
		background-color: black;
	}

	#header .menuItemActive {
		color: white;
		background-color: black;
	}

	#header .logo {
		text-align: right;
		margin-top: 10px;
		margin-right: 10px;
	}

	#header .menuEnabled {
		pointer-events: all;
		opacity: 1;
	}

	.nav-right {
		display: flex;
	}
</style>